import { render, staticRenderFns } from "./eventolaborantes.vue?vue&type=template&id=4c2c5528&scoped=true"
import script from "./eventolaborantes.vue?vue&type=script&lang=js"
export * from "./eventolaborantes.vue?vue&type=script&lang=js"
import style0 from "./eventolaborantes.vue?vue&type=style&index=0&id=4c2c5528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c5528",
  null
  
)

/* custom blocks */
import block0 from "./eventolaborantes.vue?vue&type=custom&index=0&blockType=div&class=row"
if (typeof block0 === 'function') block0(component)
import block1 from "./eventolaborantes.vue?vue&type=custom&index=1&blockType=div&class=row%20mt-3&v-if=apoyo_pagado.length%3E0%20%7C%7C%20relator_pagado.length%3E0"
if (typeof block1 === 'function') block1(component)

export default component.exports